
export function isMandatory(data) {
  if (data && data.cellSet) {
    const { mandatory, cellSet, readonly } = data;
    return mandatory && !readonly && !(cellSet.value && cellSet.value.length);
  }
  return false;
}

export function isActive(col, row, active) {
  return typeof active === 'string' && col + row === active;
}

export function getDataCell(data, r, c) {
  return data.get(`${c}${r}`);
}

const round = (val) => Math.floor(val / 10);

// eslint-disable-next-line max-len
export function getEntry({ scrollLeft }, rows) {
  let offset = 0;
  for (let i = 0; i < rows.length - 1; i++) {
    const prev = offset;
    const next = offset + rows[i].offsetWidth;

    if (round(prev) === round(scrollLeft)) {
      return [i === 0 ? 0 : rows[i - 1].offsetLeft, next];
    }

    if (round(next) === round(scrollLeft)) {
      const n = i + 2;
      return [prev, rows.length > n ? rows[n].offsetLeft : next];
    }

    if (prev < scrollLeft && scrollLeft < next) {
      return [prev, next];
    }
    offset = next;
  }
  return [0, rows[rows.length - 1].offsetLeft];
}
